import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Privacy from './views/privacy'
import Aplicacion from './views/aplicacion'
import Soporte from './views/soporte'
import Home from './views/home'
import Bluetooth from './views/bluetooth'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Privacy} exact path="/privacy" />
        <Route component={Aplicacion} exact path="/aplicacion" />
        <Route component={Soporte} exact path="/soporte" />
        <Route component={Home} exact path="/" />
        <Route component={Bluetooth} exact path="/bluetooth" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
